import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Sgkc036aRequest, SGKC036AService, ReimporttargetLstInfo } from 'sg-api';

/**
 * 電気確定使用量再取込対象取得API使用サービス
 * @export
 * @class UsedSgkc036aService
 */
@Injectable({
    providedIn: 'root'
})
export class UsedSgkc036aService {

    /** 電気確定使用量再取込対象取得結果のSubject */
    private _reimportTargetListResult$: Subject<Array<ReimporttargetLstInfo>> = new Subject<Array<ReimporttargetLstInfo>>();

    /**
     * コンストラクタ
     * @param {SGKC036AService} sGKC036AService
     * @param {ApiCommonService} apiCommonService
     * @param {TimeApiService} timeApiService
     * @param {FeaturesLibConfig} featuresLibConfig
     * @memberof UsedSgkc036aService
     */
    constructor(
        private sGKC036AService: SGKC036AService,
        private apiCommonService: ApiCommonService,
        private timeApiService: TimeApiService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
    ) { }

    /**
     * 電気確定使用量再取込対象取得結果のobservable提供
     * @readonly
     * @memberof UsedSgkc036aService
     */
    get reimportTargetListChanges() {
        return this._reimportTargetListResult$.asObservable();
    }

    /**
     * 電気確定使用量再取込対象取得API呼び出し
     * @param {Sgkc036aRequest} request 
     * @return {Observable<Array<ReimporttargetLstInfo>>} 
     * @memberof UsedSgkc036aService
     */
    searchElecReimportTargetList(request: Sgkc036aRequest): Observable<Array<ReimporttargetLstInfo>> {
        // 年月日項目のフォーマット
        this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
        // 検索条件を保存
        return this.sGKC036AService.kC10RSGKC036APost(<Sgkc036aRequest>this.apiCommonService.setRequestCommon(request), 'response')
            .pipe(
                map(response => {
                    // エラーが設定されていないかチェックする
                    this.apiCommonService.checkError(response);
                    this._reimportTargetListResult$.next(response.body.reimporttargetLstInformationlist);
                    return response.body.reimporttargetLstInformationlist;
                }),
                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC036A');
                    return throwError(err.message);
                })
            );
    }
}
